import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { Observable, map, of } from 'rxjs';

import { EntryBucketComponent } from '@app/pages/home/entry-bucket/entry-bucket.component';
import { PageRoutePath } from '@shared/constants';
import { FooterComponent } from '@shared/components/footer/footer.component';
import { PageBasedComponent } from '@app/pages/page.based.component';
import { LoadingSpinnerComponent } from '@shared/components/loading-spinner/loading-spinner.component';
import { DMPRole } from '@app/shared/enums';

@Component({
  selector: 'app-home',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    EntryBucketComponent,
    MatToolbarModule,
    FooterComponent,
    CommonModule,
    LoadingSpinnerComponent,
    MatIconModule,
    RouterLink,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent extends PageBasedComponent {
  pageRoutePath = PageRoutePath;

  isnotSupervisor$: Observable<boolean> = of(false);

  override ngOnInit(): void {
    super.ngOnInit();

    this.isnotSupervisor$ = this.profileMe$.pipe(map(profileMe => profileMe && profileMe.role_id !== DMPRole.SUPERVISOR ? true : false));
  }
}
